import {
  Event,
  FeatureAppDetails,
  Form,
  DigitalLeadsFormLoad,
  DigitalLeadsFormInput,
  DigitalLeadsDataLayerEvent,
  DigitalLeadsFormSubmissionAttempt,
  DigitalLeadsFormSubmissionSuccess,
  DigitalLeadsFormSubmissionError,
  Promotion,
} from '../types/analytics';

type InitialLoadTrigger = (
  form: Form,
  vehicleDetails: any,
  featureApp: FeatureAppDetails,
  promotion?: Promotion,
  // eslint-disable-next-line
  payload?: any,
) => void;

// extend window interface so we can add a global
declare global {
  interface Window {
    ixisDataLayer: DigitalLeadsDataLayerEvent[];
  }
}

if (typeof window !== 'undefined') {
  window.ixisDataLayer = window.ixisDataLayer || [];
}

export const digitalLeadsFormLoad: InitialLoadTrigger = (
  form,
  vehicleDetails,
  featureApp,
  promotion,
) => {
  const event: Event<DigitalLeadsFormLoad> = {
    digitalLeads: {
      type: 'digital_leads_form_load',
      form,
      vehicle: vehicleDetails,
      featureApp,
      promotion,
    },
  };

  if (typeof window !== 'undefined') {
    window.ixisDataLayer.push(event);
  }
};

export const digitalLeadsFormInput: InitialLoadTrigger = (
  form,
  vehicleDetails,
  featureApp,
  promotion,
  input,
) => {
  const event: Event<DigitalLeadsFormInput> = {
    digitalLeads: {
      type: 'digital_leads_form_input',
      form,
      vehicle: vehicleDetails,
      featureApp,
      promotion,
      payload: { input },
    },
  };

  if (typeof window !== 'undefined') {
    window.ixisDataLayer.push(event);
  }
};

export const digitalLeadsFormSubmissionAttempt: InitialLoadTrigger = (
  form,
  vehicleDetails,
  featureApp,
  promotion,
  element,
) => {
  const event: Event<DigitalLeadsFormSubmissionAttempt> = {
    digitalLeads: {
      type: 'digital_leads_form_submission_attempt',
      form,
      vehicle: vehicleDetails,
      featureApp,
      promotion,
      payload: { element },
    },
  };

  if (typeof window !== 'undefined') {
    window.ixisDataLayer.push(event);
  }
};
export const digitalLeadsFormSubmissionSuccess: InitialLoadTrigger = (
  form,
  vehicleDetails,
  featureApp,
  promotion,
) => {
  const event: Event<DigitalLeadsFormSubmissionSuccess> = {
    digitalLeads: {
      type: 'digital_leads_form_submit_success',
      form,
      promotion,
      vehicle: vehicleDetails,
      featureApp,
    },
  };

  if (typeof window !== 'undefined') {
    window.ixisDataLayer.push(event);
  }
};

export const digitalLeadsFormSubmissionError: InitialLoadTrigger = (
  form,
  vehicleDetails,
  featureApp,
  promotion,
  error,
) => {
  const event: Event<DigitalLeadsFormSubmissionError> = {
    digitalLeads: {
      type: 'digital_leads_form_submit_error',
      form,
      promotion,
      vehicle: vehicleDetails,
      featureApp,
      payload: { error },
    },
  };

  if (typeof window !== 'undefined') {
    window.ixisDataLayer.push(event);
  }
};
